import Vue from 'vue';
import SiteHeader from '../../components/SiteHeader';
import SiteFooter from '../../components/SiteFooter';
import setCookie from '../../libs/setCookie';
import i18n from '../../i18n';

// 构造页头
new Vue({
  i18n,
  el: '#header',
  data: {
    isLogin: false,
    userId: null,
    userName: null,
  },
  created() {
    const userId = setCookie('userId');
    const cUserId = setCookie('cUserId');

    if (userId && cUserId) {
      const userName = setCookie(`XM_${userId}_UN`);
      this.userId = userId;
      this.isLogin = true;

      if (userName) {
        this.userName = userName;
      } else {
        if (process.env.NODE_ENV === 'development') {
          this.userName = userId;
          return false;
        }

        this.getUserName(this.userId);
      }
    }

    return true;
  },
  methods: {
    getUserName(uid) {
      const script = document.createElement('script');
      script.src =
        `http://account.xiaomi.com/pass/userInfoJsonP?userId=${uid}&callback=setLoginInfo_getAccountInfo`;
      script.type = 'text/javascript';
      script.async = true;
      document.getElementsByTagName('head')[0].appendChild(script);

      /* eslint-disable */
      window.setLoginInfo_getAccountInfo = (data) => {
        if (this.userId) {
          this.userName = (data.miliaoInfo.nickName) ? data.miliaoInfo.nickName : data.userId;
          setCookie('XM_' + data.userId + '_UN', this.userName, {
            path: '/',
            domain: '.mi.com' }
          );
        }
      };
      /* eslint-enable */
    },
  },
  render: h => h(SiteHeader),
});

new Vue({
  el: '#footer',
  render: h => h(SiteFooter),
});

jQuery(($) => {
  function resizeMinHeight() {
    const $main = $('.site-main');
    $main.css('min-height', $(window).height() - 45 - 40 - 20 - parseInt($main.css('margin-top'), 10));
  }

  resizeMinHeight();
  $(window).on('resize', resizeMinHeight);
});



// WEBPACK FOOTER //
// ./src/modules/index/main.js